// UI SESSION — "is the screen I am about to write still the screen I belong to?"
//
// THE AXIS THIS IS NOT
//   `utils/latestOnly.js` answers a different question: "is my response still the newest REQUEST
//   of its kind?". Round 8 used one counter for both and every one of round 9's three findings is
//   that conflation:
//
//     closing a dialog is a UI act, and it advanced the REQUEST token   -> a successful save
//        invalidated its own success message and left a loading snackbar up for ever
//     opening a dialog is a UI act, and it advanced NOTHING             -> an old save closed the
//        dialog the operator had just opened for a different route
//
//   The two are independent: a request can be the newest one and still belong to a dialog the
//   operator has left, and a dialog can be untouched while a newer request supersedes an older one.
//
// THE DIFFERENCE IN ONE LINE
//   `createLatestOnly().begin()` CLAIMS — it allocates a new token, so calling it invalidates
//   whoever held the last one. `createUiSession().current()` only READS — two requests can belong
//   to the same dialog session at once, which is exactly right, because they do. Only
//   `transition()` ends a session, and only a real UI transition may call it.
//
// WHO CALLS WHAT
//   transition()  a MUTATION that changes which dialog/panel is on screen (open, close, switch).
//   current()     an ACTION, at request start, to gate DISPLAY decisions after its await.
// THE SAME AXIS, CARRIED IN VUEX STATE — for a session a COMPONENT has to read.
//
// A module-scope closure is invisible to a component, and two dialogs are closed by their own
// `.vue` after awaiting a save. They need the identical question ("is the dialog I would close
// still the one I was submitted from?") in a form `mapState` can see. Not a second mechanism: the
// same counter, a different carrier, chosen only because of who has to read it.
// (`importBookingDialog`'s `panel_session` is this pattern, predating the helper.)
export function advanceStateSession(state) {
  state.session += 1
}

export function createUiSession() {
  let session = 0
  return {
    // The screen changed: everything captured before this belongs to a screen that is gone.
    transition() {
      session += 1
    },
    // Capture the session on screen NOW. Does not end it — see the note above.
    current() {
      const mine = session
      return () => mine === session
    }
  }
}
